import { render, staticRenderFns } from "./ChbBasicCountryDataFields.vue?vue&type=template&id=6de9de60"
import script from "./ChbBasicCountryDataFields.vue?vue&type=script&lang=js"
export * from "./ChbBasicCountryDataFields.vue?vue&type=script&lang=js"
import style0 from "./ChbBasicCountryDataFields.vue?vue&type=style&index=0&id=6de9de60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports